import { openSubValuationModal } from '../../../State/subValuationModal'

export default () => (dispatch) => {

  dispatch(openSubValuationModal())

}
